<script>
import formatDate from '@utils/format-date'
import { authComputed, orderComputed, merchantComputed } from "@store/helpers";
import {
  getCategoryOption,
  getMemberApplicablePrepaidOption,
  getMemberPetOption,
  getSizeOption,
  getStoreOption,
  memberApplicablePrepaidOptions,
  memberPetOptions,
} from "@utils/ipetbooking-options";
import _uniq from "lodash/uniq";
import { getDefaultApplicablePrepaidPetId, getDefaultIsUsePrepaid } from "@utils/ipetbooking-get-default";
import { reservationIsExpired } from "@utils/ipetbooking-reservation";
import { conditionList } from "@utils/is-condition";
import { elementGetOffsetTop } from "@utils/element";
import { replaceWindowHistory } from "@utils/window-history"

export default {
  page() {
    return {
      title: `${ this.storeItem.title }`,
    }
  },
  components: {
    Layout: () => import("@layout/main"),
    SectionMenu: () => import("./components/IndexJtails/SectionMenu.Jtails"),
    ReservationSection: () => import("@components/Reservation/ReservationSection"),
    StoreSection: () => import("@components/Store/StoreSection"),
    SectionIntroduce: () => import("./components/IndexJtails/SectionIntroduce.Jtails"),
  },
  props: {
    storeItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    serviceList: {
      type: Array,
      default: () => {
        return [
          {
            title: 'A. 小美容',
            description: '洗澡小美容服務項目包含：剪指甲／剃腳底毛／剃肛門毛／剃肚子毛／清耳朵／擠肛門腺／小修足緣／小修臉部雜毛',
            items: [
              {
                title: '迷你 (3kg以下)',
                alias: 'alias1',
                price: 900,
                serviceTime: 90
              },
            ],
          },
        ]
      }
    }
  },
  data() {
    return {
      menuList: [],
      submitData: {
        storeAlias: '',
        time: '',
        date: '',
        category: '',
        petId: '',
        sizeAlias: '',
        isUserMemberPet: false,
        isUsePrepaid: false,
        types: ['cosmetic']
      },
      tempSubmitData: {},
      reservationList: [],
      reservationPagination: {},
      prepaidOrderList: [],
      prepaidOrderPagination: {},
      windowResizeObserver: null,
      isInit: false
    }
  },
  computed: {
    ...authComputed,
    ...orderComputed,
    ...merchantComputed,
    bannerImage() {
      const isHome = this.storeItem?.storeType === 'home';
      const defaultBanner = isHome ? 'another_banner@2.jpg' : 'banner@2.jpg'
      return this.getDefaultImage(this.storeItem.images) || require(`@assets/images/jtails/v2/一般預約/3分店頁/${defaultBanner}`)
    }
  },
  mounted() {
    const initWindowResizeObserver = () => {
      this.windowResizeObserver = new ResizeObserver(entries => {
        this.setMenuList();
      });

      this.windowResizeObserver.observe(document.querySelector('.el-scrollbar__view') || document.getElementById('app') );
    };

    const initResizeListener = () => {
      window.addEventListener('resize', this.setMenuList);
    };

    initWindowResizeObserver();
    initResizeListener();
    setTimeout(() => {
      this.setMenuList();
    }, 600);
  },
  destroyed() {
    const removeWindowResizeObserver = () => {
      this.windowResizeObserver.disconnect();
    };

    const removeResizeListener = () => {
      window.removeEventListener('resize', this.setData)
    };

    removeResizeListener();
    removeWindowResizeObserver();
  },
  methods: {
    onInit() {
      this.isInit = true;
      this.setTempSubmitData();

      if(this.submitData.isUsePrepaid) {
        this.tryToFetchApplicablePrepaidOrderList({
          callbackScroll: false
        });
      } else {
        this.tryToFetchReservationList({
          callbackScroll: false
        });
      }
    },
    onSubmit(params) {
      if(this.submitData.isUsePrepaid) {
        this.tryToFetchApplicablePrepaidOrderList({ params });
      }else {
        this.tryToFetchReservationList({ params });
      }
    },
    tryToFetchApplicablePrepaidOrderList({ params, callbackScroll = true }= {}) {
      const sizeAlias = this.submitData.isUserMemberPet ? getMemberPetOption({
          value: this.submitData.petId,
        }).sizeAlias : this.submitData.sizeAlias
      const petId = this.submitData.isUserMemberPet ? this.submitData.petId : undefined

      this.$store.dispatch('order/fetchApplicablePrepaidOrderList', {
        ...this.submitData,
        ...params,
        sizeAlias,
        petId,
        date: undefined,
      })
        .then(({
          items,
          pagination
        }) => {
          const setData = () => {
            this.prepaidOrderList = items;
            this.prepaidOrderPagination = pagination;
          };

          setData();
          this.setTempSubmitData();
          this.replaceHistory();

          /* if(callbackScroll) {
            if(this.$globalWindowWidth <= 991) {
              this.scrollToId('reservation-list')
            } else {
              this.scrollToSectionList();
            }
          } */
        })
    },


    tryToFetchReservationList({ params, callbackScroll = true }= {}) {
      const sizeAlias = this.submitData.isUserMemberPet ? getMemberPetOption({
          value: this.submitData.petId,
        }).sizeAlias : this.submitData.sizeAlias
      const petId = this.submitData.isUserMemberPet ? this.submitData.petId : undefined

      this.$store.dispatch('merchant/fetchReservationList', {
        ...this.submitData,
        ...params,
        sizeAlias,
        petId,
        order_by: 'groupOrdering',
      })
      .then(({
        items,
        pagination
      }) => {
        const setData = () => {
          this.reservationList = items;
          this.reservationPagination = pagination;
        };

        setData();
        this.setTempSubmitData();
        this.replaceHistory();

        /* if(callbackScroll) {
          if(this.$globalWindowWidth <= 991) {
            this.scrollToId('reservation-list')
          } else {
            this.scrollToSectionList();
          }
        } */
      })
    },
    setTempSubmitData() {
      this.tempSubmitData = { ...this.submitData };
    },
    replaceHistory() {
      replaceWindowHistory({
        query: {
          ...this.$route.query,
          ...this.submitData
        }
      })
    },
    scrollToSectionList() {
      this.$scrollToElement({
        $el: this.$refs['sectionList'].$el,
        offset: 70,
      });
    },
    scrollToId(id) {
      this.$scrollToElement({
        $el: document.getElementById(id || ''),
        offset: -70,
      });
    },
    setMenuList() {
      this.menuList = conditionList([
        {
          title: '所有服務',
          id: 'reservation',
          offsetTop: elementGetOffsetTop(document.getElementById('reservation')),
          condition: () => {
            return !!this.isSiteEnabled
          },
        },
        {
          title: '店面介紹',
          offsetTop: elementGetOffsetTop(document.getElementById('store')),
          id: 'store',
          condition: () => {
            return true
          },
        },
        {
          title: '服務介紹',
          offsetTop: elementGetOffsetTop(document.getElementById('introduce')),
          id: 'introduce',
          condition: () => {
            return !!this.storeItem.description
          },
        },
      ]);
    },
    getDefaultImage(images) {
      const defaultImageItems = images.filter(image => image.default) || [];

      return defaultImageItems[0]?.path || ''
    },
  }
}
</script>
<!-- section template -->
<template>
  <Layout :class="$style.viewStore">
    <BaseBannerJtails
      :title="storeItem.title"
      :image="bannerImage"
    />
    <SectionMenu
      class="viewStore__menu"
      :menu-list="menuList"
    />

    <ReservationSection
      v-if="!!isSiteEnabled"
      v-show="isInit"
      id="reservation"
      ref="sectionList"
      v-model="submitData"
      type="reservation"
      :store-item="storeItem"
      :service-list="serviceList"
      :reservation-list="reservationList"
      :reservation-pagination="reservationPagination"
      :prepaid-order-list="prepaidOrderList"
      :prepaid-order-pagination="prepaidOrderPagination"
      :temp-submit-data="tempSubmitData"
      @submitCallback="onSubmit"
      @init="onInit"
    />

    <BasePre>
      tempSubmitData: {{ tempSubmitData }}
    </BasePre>

    <StoreSection
      id="store"
      :store-item="storeItem"
    />

    <SectionIntroduce
      :store-item="storeItem"
    />
    <BasePre>
      {{ storeItem }}
    </BasePre>

  </Layout>
</template>
<!-- section style -->
<style lang="scss" module>
.viewStore {
  :global {
    .viewStore {
      &__menu {
        position: sticky;
        top: 80px;
        z-index: 2;

        @include max-lg {
          display: none;
        }
      }
    }
  }
}
</style>
